// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603301425/js/" + chunkId + "." + {"44":"3acecc2c","225":"c68130ef","481":"6d676fb8","486":"015223ca","770":"f7f0e1dd"}[chunkId] + ".0.42399448333779177.chunk.js";
};